<template>
  <div>
    <UploadImageCautionArea
      v-if="!isVerified"
      :cautions="cautions"
      class="mb-4"
    />
    <ValidationProvider
      v-slot="validationState"
      name="資格"
      tag="div"
      rules="required"
      vid="qualification"
    >
      <FormSelectGroup
        label="資格種別"
        appLabelText="必須"
        v-model="inputValues.qualification"
        :options="qualificationOptions"
        text-field="name"
        value-field="id"
        :validation-state="validationState"
        class="mb-4"
        :disabled="disabled"
      />
    </ValidationProvider>
    <UploadImageForm
      v-model="inputValues.image"
      photoGraphingType="qualification"
      appLabelText="必須"
      appLabelVariant="red"
      :isFrontCamera="false"
      v-model:isCameraActive="isCameraActiveValue"
      :options="options"
      :disabled="disabled"
      :disabledText="disabledText"
    >
      <QualificationImage :imageUrl="inputValues.image" />
    </UploadImageForm>
  </div>
</template>

<script lang="ts">
import FormSelectGroup from "@/components/molecules/form/FormSelectGroup.vue";
import QualificationImage from "@/components/molecules/other/QualificationImage.vue";
import UploadImageCautionArea from "@/components/molecules/other/UploadImageCautionArea.vue";
import UploadImageForm from "@/components/organisms/register/UploadImageForm.vue";
import { Qualification } from "@/types/Master";
import { UserQualificationInputValues } from "@/types/qualification/EditableUserQualificationItems";
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  components: {
    FormSelectGroup,
    UploadImageCautionArea,
    UploadImageForm,
    QualificationImage
  }
})
export default class AddQualification extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  value!: UserQualificationInputValues;

  @Prop({
    type: Array,
    required: true
  })
  qualificationOptions!: Qualification[];

  @Prop({
    type: Boolean,
    required: true
  })
  isCameraActive!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop({
    type: String,
    default: ""
  })
  disabledText!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  isVerified!: boolean;

  get inputValues() {
    return this.value;
  }

  set inputValues(v) {
    if (this.value !== v) this.$emit("input", v);
  }

  get isCameraActiveValue() {
    return this.isCameraActive;
  }

  set isCameraActiveValue(v) {
    this.$emit("update:isCameraActive", v);
  }

  get options() {
    return [
      "[資格証の全体]が入っていますか？",
      "反射なく、はっきり読み取れますか？"
    ];
  }

  get cautions() {
    return [
      "四隅が写真に収まっている",
      "印字内容が鮮明",
      "関係ないものが写っていない",
      "撮影するのは1枚の資格証のみ"
    ];
  }
}
</script>
